import React from 'react';
import { Button } from 'antd';
import { PlusOutlined } from '@ant-design/icons';

const EmptyState = ({ onCreateNew }) => {
    return (
        <div className="flex-1 flex items-center justify-center bg-gray-50 p-4">
            <div className="text-center">
                <div className="text-5xl sm:text-6xl mb-4">💬</div>
                <h3 className="text-lg sm:text-xl font-semibold text-gray-700 mb-2">
                    Select a conversation
                </h3>
                <p className="text-sm sm:text-base text-gray-500 mb-4">
                    Choose a conversation from the list or create a new one
                </p>
                <Button
                    type="primary"
                    icon={<PlusOutlined />}
                    onClick={onCreateNew}
                    className="bg-[#298d9f]"
                    size="large"
                >
                    Create New OVR
                </Button>
            </div>
        </div>
    );
};

export default EmptyState;